import React from 'react';

import isNil from 'lodash/isNil';

import Select from '@atlaskit/select';

import {
  ExecutionStatusColor,
  StatusColorSelectOption,
} from '@qality/common-model';
import { CssUtils, StringUtils } from '@qality/common-utils';

import {
  ColorIconStyled,
  StatusColorSelectOptionStyled,
} from './StatusColorSelect.styled';

type Props = {
  onChange: (value: ExecutionStatusColor) => void;
  options?: Array<ExecutionStatusColor>;
  isLoading?: boolean;
  defaultValue?: ExecutionStatusColor;
};

export default function StatusColorSelect({
  onChange,
  options = [],
  defaultValue,
  isLoading = false,
}: Props): JSX.Element {
  const mapStatusColorsToOptions = (
    optionsArg: Array<ExecutionStatusColor>
  ): Array<StatusColorSelectOption> => {
    return optionsArg
      .map(mapStatusColorToOption)
      .sort((a, b) => a.label.localeCompare(b.label));
  };

  const mapStatusColorToOption = (
    option: ExecutionStatusColor
  ): StatusColorSelectOption => {
    return {
      label: option.name,
      value: option,
    };
  };

  return (
    <div style={{ width: '204px' }}>
      <Select
        isLoading={isLoading}
        onChange={(target) => {
          onChange(target.value);
        }}
        options={isNil(options) ? [] : mapStatusColorsToOptions(options)}
        defaultValue={
          !isNil(defaultValue)
            ? mapStatusColorToOption(defaultValue)
            : mapStatusColorsToOptions(options)[0]
        }
        placeholder={isLoading ? 'Loading...' : 'Select status color'}
        formatOptionLabel={(option: StatusColorSelectOption) => {
          return (
            <StatusColorSelectOptionStyled>
              <ColorIconStyled
                color={CssUtils.cssDsTokenVar(option.value.backgroundToken)}
              />
              {StringUtils.capitalize(option.label)}
            </StatusColorSelectOptionStyled>
          );
        }}
      />
    </div>
  );
}
